export const apiUrl = import.meta.env.VITE_API_URL